import { render, staticRenderFns } from "./PotentialDataOwner.vue?vue&type=template&id=5fd3396e"
import script from "./PotentialDataOwner.vue?vue&type=script&lang=js"
export * from "./PotentialDataOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports